import { render, staticRenderFns } from "./PhotoIDExpirationNotification.vue?vue&type=template&id=78e5fc3b"
import script from "./PhotoIDExpirationNotification.vue?vue&type=script&lang=js"
export * from "./PhotoIDExpirationNotification.vue?vue&type=script&lang=js"
import style0 from "./PhotoIDExpirationNotification.vue?vue&type=style&index=0&id=78e5fc3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports